import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { reservationAPI } from '../../utils/api';
import { toast } from 'react-toastify';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        total_reservations: 0,
        today_reservations: 0,
        pending_reservations: 0,
        total_revenue: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await reservationAPI.getStats();
            setStats(response.data.data);
        } catch (error) {
            console.error('Stats error:', error);
            toast.error('İstatistikler yüklenemedi');
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        toast.success('Çıkış yapıldı');
        navigate('/admin/login');
    };

    if (loading) {
        return (
            <div className="admin-page">
                <div className="loading">Yükleniyor...</div>
            </div>
        );
    }

    return (
        <div className="admin-page">
            <div className="admin-header">
                <h1>🚕 Admin Paneli</h1>
                <button onClick={handleLogout} className="btn-logout">
                    Çıkış Yap
                </button>
            </div>

            <div className="dashboard-container">
                <div className="stats-grid">
                    <div className="stat-card">
                        <div className="stat-icon">📊</div>
                        <div className="stat-info">
                            <h3>Toplam Rezervasyon</h3>
                            <p className="stat-number">{stats.total_reservations}</p>
                        </div>
                    </div>

                    <div className="stat-card">
                        <div className="stat-icon">📅</div>
                        <div className="stat-info">
                            <h3>Bugünkü Rezervasyonlar</h3>
                            <p className="stat-number">{stats.today_reservations}</p>
                        </div>
                    </div>

                    <div className="stat-card">
                        <div className="stat-icon">⏳</div>
                        <div className="stat-info">
                            <h3>Bekleyen Rezervasyonlar</h3>
                            <p className="stat-number">{stats.pending_reservations}</p>
                        </div>
                    </div>


                </div>

                <div className="quick-actions">
                    <h2>Hızlı İşlemler</h2>
                    <div className="actions-grid">
                        <Link to="/admin/vehicles" className="action-card">
                            <span className="action-icon">🚕</span>
                            <h3>Araç Yönetimi</h3>
                            <p>Araçları görüntüle, ekle, düzenle</p>
                        </Link>

                        <Link to="/admin/reservations" className="action-card">
                            <span className="action-icon">📋</span>
                            <h3>Rezervasyonlar</h3>
                            <p>Rezervasyonları yönet</p>
                        </Link>

                        <Link to="/" className="action-card" target="_blank">
                            <span className="action-icon">🌐</span>
                            <h3>Siteyi Görüntüle</h3>
                            <p>Kullanıcı tarafını gör</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
